function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #959595;\n      }\n    "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "servicios",
  transform: "translate(-422.017 -396.677)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_120",
  "data-name": "Grupo 120"
}, /*#__PURE__*/React.createElement("path", {
  id: "Trazado_80",
  "data-name": "Trazado 80",
  className: "cls-1",
  d: "M451.747,400.612a.159.159,0,0,0-.106-.142.265.265,0,0,0-.178.036l-3.193,3.122-3.3-3.3,3.194-3.193a.171.171,0,0,0,0-.248c-.036-.036-.036-.036-.071-.036a7.5,7.5,0,0,0-6.706,1.845c-1.7,1.7-1.278,3.69-.994,5,.036.178.071.39.107.532-1.136,1.207-9.722,9.829-11,11.035-.142-.035-.284-.071-.461-.106-1.313-.32-3.229-.781-5,.958a7.36,7.36,0,0,0-1.845,6.635.2.2,0,0,0,.213.142.125.125,0,0,0,.071-.036l3.193-3.122,3.3,3.3-3.193,3.193a.171.171,0,0,0,0,.248c.035.036.035.036.071.036a7.542,7.542,0,0,0,1.561.177,7.33,7.33,0,0,0,5.145-2.058c1.7-1.7,1.277-3.69.993-5-.035-.177-.071-.39-.106-.532,1.135-1.206,9.722-9.828,11-11.035l.461.107c1.278.319,3.265.816,5-.923A7.456,7.456,0,0,0,451.747,400.612Z"
})));

function SvgServicios(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.89,
    height: 30.014,
    viewBox: "0 0 29.89 30.014",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServicios);
export default __webpack_public_path__ + "static/media/servicios.52f9160c.svg";
export { ForwardRef as ReactComponent };